import React from 'react';
import { getWeeklyVerse } from '../../utils/weeklyVerse';
import { t } from '../../utils/translations';

const WeeklyVerseWidget: React.FC = () => {
  const verse = getWeeklyVerse();

  return (
    <section className="rounded-xl border border-brand-100 bg-brand-50/60 p-5 sm:p-6">
      <p className="mb-2 text-[10px] font-semibold uppercase tracking-widest text-brand-600/80">
        {t.dashboard.weeklyVerse}
      </p>
      <p className="text-sm italic leading-relaxed text-slate-600">
        „{verse.text}” — {verse.reference}
      </p>
    </section>
  );
};

export default WeeklyVerseWidget;
